module.exports = __webpack_public_path__ + "static/media/E1C12C8E-5E5D-4356-AFB9-F3D22EAF20EB.fd447fef.jpeg";